/* HEDO mobile sticky purchase bar — TEST theme only (2026-10-08)
   Reads everything from the original buy box and clicks the original
   Add to cart button, so variant, quantity, availability and cart behaviour
   are exactly the theme's own. Mobile (<750px) only. */
(function () {
  var bar = document.getElementById('HedoStickyAtc');
  if (!bar) return;

  var mq = window.matchMedia('(max-width: 749px)');
  var root = document.documentElement;
  var priceEl = bar.querySelector('[data-satc-price]');
  var variantEl = bar.querySelector('[data-satc-variant]');
  var btn = bar.querySelector('[data-satc-button]');
  var labelEl = bar.querySelector('[data-satc-label]');

  var info, form, origBtn, observer, io, controlsInView = true, raf = 0;

  /* ---- widget positioning (shadow-DOM apps) ------------------------------ */
  var SHADOW_CSS =
    /* Shopify Forms minimised "10% OFF" teaser only — never the open popup */
    "[class*='_appEmbedRootTeaser']{translate:0 calc(-1 * var(--hedo-satc-offset, 0px));transition:translate .25s ease}" +
    /* accessibility widget launcher (bottom position only) */
    '.trigger-button.position-y-bottom{translate:0 calc(-1 * var(--hedo-satc-offset, 0px));transition:translate .25s ease}';
  var sheet = null;
  try {
    sheet = new CSSStyleSheet();
    sheet.replaceSync(SHADOW_CSS);
  } catch (e) {
    sheet = null;
  }

  function patchShadowRoots() {
    var hosts = document.querySelectorAll('shopify-forms-embed, access-widget-ui');
    for (var i = 0; i < hosts.length; i++) {
      var sr = hosts[i].shadowRoot;
      if (!sr || sr.__hedoSatc) continue;
      try {
        if (sheet && 'adoptedStyleSheets' in sr) {
          sr.adoptedStyleSheets = sr.adoptedStyleSheets.concat([sheet]);
        } else {
          var s = document.createElement('style');
          s.textContent = SHADOW_CSS;
          sr.appendChild(s);
        }
        sr.__hedoSatc = true;
      } catch (e) {
        /* leave the widget exactly as the app renders it */
      }
    }
  }

  /* ---- mirror the original buy box --------------------------------------- */
  function text(el) {
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function sync() {
    raf = 0;
    if (!info) return;
    var section = info.dataset.section;

    // price
    var price = document.getElementById('price-' + section);
    var priceHidden = !price || price.classList.contains('hidden');
    var html = '';
    if (!priceHidden) {
      var p = price.querySelector('.price');
      if (p && p.classList.contains('price--on-sale')) {
        var sale = text(p.querySelector('.price__sale .price-item--sale'));
        var compare = text(p.querySelector('.price__sale s .price-item--regular, .price__sale s'));
        html = sale + (compare ? '<s>' + compare + '</s>' : '');
      } else if (p) {
        html = text(p.querySelector('.price__regular .price-item--regular'));
      }
    }
    priceEl.innerHTML = html;
    priceEl.hidden = !html;

    // selected variant label (only when the product has real options)
    var selected = info.querySelector('variant-selects [data-selected-variant]');
    var vTitle = '';
    if (selected) {
      try {
        var v = JSON.parse(selected.textContent);
        if (v && v.title && v.title !== 'Default Title') vTitle = v.title;
      } catch (e) {}
    }
    variantEl.textContent = vTitle;

    // availability + loading state, straight from the original button
    origBtn = info.querySelector('button[name="add"]');
    if (origBtn) {
      var disabled = origBtn.hasAttribute('disabled');
      var loading = origBtn.classList.contains('loading') || origBtn.getAttribute('aria-disabled') === 'true';
      btn.disabled = disabled;
      btn.setAttribute('aria-disabled', disabled || loading ? 'true' : 'false');
      btn.classList.toggle('is-loading', loading && !disabled);
      labelEl.textContent = text(origBtn.querySelector('span')) || labelEl.textContent;
    }
  }

  function scheduleSync() {
    if (!raf) raf = requestAnimationFrame(sync);
  }

  /* ---- visibility ----------------------------------------------------------- */
  function setVisible(show) {
    bar.classList.toggle('is-visible', show);
    if (show) {
      bar.removeAttribute('aria-hidden');
      bar.removeAttribute('inert');
      btn.removeAttribute('tabindex');
    } else {
      bar.setAttribute('aria-hidden', 'true');
      bar.setAttribute('inert', '');
      btn.setAttribute('tabindex', '-1');
    }
    root.style.setProperty(
      '--hedo-satc-offset',
      show ? 'calc(var(--hedo-satc-h, 64px) + env(safe-area-inset-bottom, 0px))' : '0px'
    );
  }

  function overlayOpen() {
    // Dawn adds overflow-hidden* to <body> while the menu drawer or a modal is open
    return /(^|\s)overflow-hidden/.test(document.body.className);
  }

  function update() {
    setVisible(mq.matches && !!form && !controlsInView && !overlayOpen());
  }

  function bind() {
    if (observer) observer.disconnect();
    if (io) io.disconnect();

    info = document.querySelector('product-info[id^="MainProduct-"]') || document.querySelector('product-info');
    form = info && info.querySelector('product-form');
    if (!info || !form) {
      setVisible(false);
      return;
    }

    observer = new MutationObserver(scheduleSync);
    observer.observe(info, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['disabled', 'class', 'aria-disabled'],
    });

    // "visible" = any part of the original purchase controls is on screen
    // (top margin excludes the sticky header strip)
    // also stay hidden while the original price is on screen, so the bar never covers it
    var priceBlock = document.getElementById('price-' + info.dataset.section);
    io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          e.target.__hedoSatcIn = e.isIntersecting;
        });
        controlsInView = !!(form.__hedoSatcIn || (priceBlock && priceBlock.__hedoSatcIn));
        update();
      },
      // bottom margin: step aside just before they scroll up into view, so the slide-out never overlaps them
      { rootMargin: '-60px 0px 100px 0px', threshold: 0 }
    );
    io.observe(form);
    if (priceBlock) io.observe(priceBlock);
    sync();
  }

  btn.addEventListener('click', function () {
    if (!origBtn || origBtn.hasAttribute('disabled') || origBtn.getAttribute('aria-disabled') === 'true') return;
    origBtn.click();
  });

  function enable() {
    root.classList.toggle('hedo-satc-enabled', mq.matches);
    update();
  }

  if (mq.addEventListener) mq.addEventListener('change', enable);
  else if (mq.addListener) mq.addListener(enable);

  document.addEventListener('product-info:loaded', bind);
  new MutationObserver(update).observe(document.body, { attributes: true, attributeFilter: ['class'] });

  // apps attach their shadow roots late — keep checking briefly
  patchShadowRoots();
  new MutationObserver(patchShadowRoots).observe(document.body, { childList: true });
  var tries = 0;
  var t = setInterval(function () {
    patchShadowRoots();
    if (++tries > 20) clearInterval(t);
  }, 500);

  bind();
  enable();
})();
